import env from '@core/env-config';
import { createQueryStore } from '@lib/query';

const { createMutation, createMutationWithMock } = createQueryStore({
  useMock: env.USE_MOCK === 'true'
});

export { createMutation, createMutationWithMock };
